if (!customElements.get('product-gallery-thumbnails')) {
  class ProductGalleryThumbnails extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      const signal = this._abortController.signal;
      this._targetId = this.dataset.sliderTarget;
      this._buttons = Array.from(this.querySelectorAll('[data-thumbnail-index]'));

      this._buttons.forEach(button => {
        button.addEventListener('click', this._onThumbnailClick.bind(this), { signal });
      });

      this._unsubscribeSlider = theme.pubsub?.subscribe(
        theme.pubsub.events.SLIDER_CHANGE,
        this._onSliderChange.bind(this)
      );
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._unsubscribeSlider?.();
    }

    _getSlider() {
      return this._targetId ? document.getElementById(this._targetId) : null;
    }

    _onThumbnailClick(event) {
      const index = parseInt(event.currentTarget.dataset.thumbnailIndex, 10);
      if (Number.isNaN(index)) return;
      const slider = this._getSlider();
      if (typeof slider?.navigateToSlide !== 'function') return;
      slider.navigateToSlide(index);
    }

    _onSliderChange(data) {
      if (data.id !== this._targetId) return;
      this._setActive(data.currentIndex);
    }

    _setActive(index) {
      this._buttons.forEach((button, i) => {
        const active = i === index;
        button.classList.toggle('active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    /** Re-captures the buttons and rewires them. */
    refresh() {
      this._abortController?.abort();
      this._unsubscribeSlider?.();
      this.connectedCallback();
    }

    /**
     * Inserts a thumbnail at `index` and renumbers the following
     * `data-thumbnail-index` values, then refreshes.
     */
    insertThumbnail(element, index) {
      if (!element) return;
      const buttons = Array.from(this.querySelectorAll('[data-thumbnail-index]'));
      this.insertBefore(element, buttons[index] ?? null);
      Array.from(this.querySelectorAll('[data-thumbnail-index]'))
        .forEach((button, position) => { button.dataset.thumbnailIndex = String(position); });
      this.refresh();
    }
  }

  customElements.define('product-gallery-thumbnails', ProductGalleryThumbnails);
}
